import requestWithAuth from "./httpClient";
import { rootURL } from "./rootURL";

const overviewURL = `${rootURL}overview`;

export type OverviewData = {
	clients: number;
	activeTranslators: number;
	monthTotal: number;
	monthPercentageDifference: number;
	svadbaMonthTotal: number;
	svadbaPercentageDifference: number;
	datingPercentageDifference: number;
	yearTotal: number;
	totalPayments: number;
	totalProfit: number;
	clientsSalary: number;
	paymentToScout: number;
	paymentToBot: number;
	paymentToTranslator: number;
};

export function getOverviewDataRequest({
	selectedYear = "2024",
}: {
	selectedYear?: string;
}) {
	return requestWithAuth<OverviewData>(
		"get",
		`${overviewURL}/get?selectedYear=${selectedYear}`,
	);
}
